module.exports = __webpack_public_path__ + "static/media/tdis-logo.50f1ba67.png";